/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PracticeProfileUpdateDto
 */
export interface PracticeProfileUpdateDto {
    /**
     * Provider first name
     * @type {string}
     * @memberof PracticeProfileUpdateDto
     */
    firstName: string;
    /**
     * Provider middle name
     * @type {string}
     * @memberof PracticeProfileUpdateDto
     */
    middleName?: string;
    /**
     * Provider last name
     * @type {string}
     * @memberof PracticeProfileUpdateDto
     */
    lastName: string;
    /**
     * National Provider Identifier (NPI)
     * @type {string}
     * @memberof PracticeProfileUpdateDto
     */
    npi: string;
    /**
     * Provider phone number
     * @type {string}
     * @memberof PracticeProfileUpdateDto
     */
    phoneNumber: string;
    /**
     * Provider specialties
     * @type {Array<string>}
     * @memberof PracticeProfileUpdateDto
     */
    specialty?: Array<string>;
    /**
     * Provider profile picture URL
     * @type {string}
     * @memberof PracticeProfileUpdateDto
     */
    profileImage?: string;
    /**
     * Provider is active
     * @type {boolean}
     * @memberof PracticeProfileUpdateDto
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the PracticeProfileUpdateDto interface.
 */
export function instanceOfPracticeProfileUpdateDto(value: object): value is PracticeProfileUpdateDto {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('npi' in value) || value['npi'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    return true;
}

export function PracticeProfileUpdateDtoFromJSON(json: any): PracticeProfileUpdateDto {
    return PracticeProfileUpdateDtoFromJSONTyped(json, false);
}

export function PracticeProfileUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PracticeProfileUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'npi': json['npi'],
        'phoneNumber': json['phoneNumber'],
        'specialty': json['specialty'] == null ? undefined : json['specialty'],
        'profileImage': json['profileImage'] == null ? undefined : json['profileImage'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function PracticeProfileUpdateDtoToJSON(json: any): PracticeProfileUpdateDto {
    return PracticeProfileUpdateDtoToJSONTyped(json, false);
}

export function PracticeProfileUpdateDtoToJSONTyped(value?: PracticeProfileUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'npi': value['npi'],
        'phoneNumber': value['phoneNumber'],
        'specialty': value['specialty'],
        'profileImage': value['profileImage'],
        'isActive': value['isActive'],
    };
}

